import { Component } from '@angular/core';
import { NotificationsWidget } from './components/notificationswidget';
import { StatsWidget } from './components/statswidget';
import { RecentSalesWidget } from './components/recentsaleswidget';
import { BestSellingWidget } from './components/bestsellingwidget';
import { RevenueStreamWidget } from './components/revenuestreamwidget';

@Component({
    selector: 'app-dashboard',
    imports: [StatsWidget],
    template: `
        <div class="grid grid-cols-12 gap-8 lg:gap-6">
            <app-stats-widget class="col-span-12" />
            <!--<div class="col-span-12 lg:col-span-6">
                <app-recent-sales-widget />
                <app-best-selling-widget />
            </div>
            <div class="col-span-12 lg:col-span-6">
                <app-revenue-stream-widget />
                <app-notifications-widget />
            </div>-->
        </div>
    `
})
export class Dashboard {}
